import { ThirdPartyLogo, LegacyDataTableRow, LegacyDataTableRowColumn } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import type { DeploymentFreezeDetailEnvironment, DeploymentFreezeScopeDetail, DeploymentFreezeScopeType, GetDeploymentFreezeByIdResponse } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import type { DoBusyTask } from "~/components/DataBaseComponent/index";
import DeploymentFreezeScopeCell from "~/components/DeploymentFreezes/EditScopeTable/DeploymentFreezeScopeCell";
import InternalLink from "~/components/Navigation/InternalLink/index";
import { OverflowMenu, OverflowMenuItems } from "~/components/OverflowMenu/OverflowMenu";
import { resolveUrl } from "~/utils/resolveUrl";
import styles from "./style.module.less";
interface DeploymentFreezeScopeTableRowProps {
    scopeItem: DeploymentFreezeScopeDetail;
    onRemove: (item: DeploymentFreezeScopeDetail) => void;
    onEnvironmentUpdate: (item: DeploymentFreezeScopeDetail, selectedEnvironments: DeploymentFreezeDetailEnvironment[]) => void;
    scopeType: DeploymentFreezeScopeType;
    doBusyTask: DoBusyTask;
    focussedScopeCellId: string;
    onFocusedScopeCell: (id: string) => void;
    onScopeCellLostFocus: () => void;
    freezeDetail?: GetDeploymentFreezeByIdResponse;
}
export const DeploymentFreezeScopeTableRow = ({ scopeItem, scopeType, onRemove, onEnvironmentUpdate, doBusyTask, focussedScopeCellId, onFocusedScopeCell, onScopeCellLostFocus, freezeDetail }: DeploymentFreezeScopeTableRowProps) => (<LegacyDataTableRow>
        <LegacyDataTableRowColumn className={styles.projectNameCell}>
            <InternalLink to={links.projectDashboardPage.generateUrl({ spaceId: scopeItem.SpaceId, projectSlug: scopeItem.Id })}>
                <div style={{ display: "flex" }}>
                    <div style={{ marginRight: space[12] }}>
                        <ThirdPartyLogo url={resolveUrl(scopeItem.LogoLink)} size="2.5em"/>
                    </div>
                    <div style={{ overflowWrap: "anywhere", alignSelf: "center" }}>{scopeItem.Name}</div>
                </div>
            </InternalLink>
        </LegacyDataTableRowColumn>
        <LegacyDataTableRowColumn className={styles.environmentNameCell}>
            <DeploymentFreezeScopeCell scope={scopeItem} scopeType={scopeType} onEnvironmentUpdate={onEnvironmentUpdate} doBusyTask={doBusyTask} onScopeCellLostFocus={onScopeCellLostFocus} onFocusedScopeCell={onFocusedScopeCell} isEditing={focussedScopeCellId === scopeItem.Id} freezeDetail={freezeDetail}/>
        </LegacyDataTableRowColumn>
        <LegacyDataTableRowColumn>
            <div className={styles.overflowMenu}>
                <OverflowMenu accessibleName="deploymentFreezesScopeOverflowMenu" menuItems={[
        OverflowMenuItems.deleteItem("Remove", `Are you sure you want to disassociate ${scopeType.toLocaleLowerCase()} '${scopeItem.Name}'?`, async () => onRemove(scopeItem), <div>
                                <p>Do you wish to continue?</p>
                            </div>),
    ]}/>
            </div>
        </LegacyDataTableRowColumn>
    </LegacyDataTableRow>);
